import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { IEnumModel } from 'src/app/models/enum.model';
import Swal from 'sweetalert2';
import { BaseFormComponent } from 'src/app/shared/components/base-form/base-form.component';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { MatDialog } from '@angular/material/dialog';
import { IModeloRelatorioModel } from 'src/app/models/modelo-relatorio.model';
import { AuthService } from 'src/app/services/auth.service';
import { IPlanejamentoPapelTrabalho, IPlanejamentoPapelTrabalhoArquivo } from 'src/app/models/planejamento-papel-trabalho.model';
import { PapeisTrabalhoService } from 'src/app/services/papeis-trabalho.service';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import { FileService } from 'src/app/services/file.service';
import { PlanejamentoService } from 'src/app/services/planejamento.service';
import { IBaseModel } from 'src/app/models/base.model';
import { ModalPapelNaoCadastradoComponent } from './modal-papel-nao-cadastrado/modal-papel-nao-cadastrado.component';
import { IPapeisTrabalhoModel } from 'src/app/models/papeis-trabalho-model';

export type IModeloRelatoria = {
  modeloRelatorio: IModeloRelatorioModel[] | IModeloRelatorioModel | any;
  modeloRelatorioId: number | any;
  habilitarGerarRelatoria: boolean;
  jaEnviadoAprovacao: boolean;
  status: IEnumModel;
  situacao: IEnumModel;

}
@Component({
  selector: 'app-planejamento-aba-papeis',
  templateUrl: './planejamento-aba-papeis.component.html',
  styleUrls: ['./planejamento-aba-papeis.component.scss']
})
export class PlanejamentoAbaPapeisComponent extends BaseFormComponent implements OnInit {
  @Input() aba: number;
  @Input() visualizar: boolean;
  @Input() submit: boolean;
  @Input() idPlanejamento: number;
  @Input() public impressao: boolean;
  public reprovado: boolean;
  public homologado: boolean;
  public emAprovacao: boolean;

  model: IPlanejamentoPapelTrabalho[] = [];
  modelRemovidos: IPlanejamentoPapelTrabalho[] = [];

  constructor(
    route: ActivatedRoute,
    toastr: ToastrService,
    router: Router,
    localeService: BsLocaleService,
    private authService: AuthService,
    public matDialog: MatDialog,
    private papeisTrabalhoService: PapeisTrabalhoService,
    private fileService: FileService,
    private planejamentoService: PlanejamentoService
  ) {
    super(route, toastr, router, localeService, matDialog);
  }

  ngOnInit(): void {

  }

  ngAfterViewInit(): void {
    this.carregaPapeisTrabalho();
  }

  carregaPapeisTrabalho() {
    this.planejamentoService
      .obterPapeisTrabalho(this.idPlanejamento)
      .then((res) => {
        this.model = res.dados as IPlanejamentoPapelTrabalho[];
      })
      .catch((err) => {
        //this.exibirMensagemAlerta(err.mensagem.descricao);
      })
  }

  ngOnChanges(changes: SimpleChanges): void {

  }

  ngDoCheck() {

  }

  public async uploadAmostra(e, item: IPlanejamentoPapelTrabalho) {
    if (item.arquivos == null || item.arquivos == undefined)
      item.arquivos = [];

    let file = (e.target as HTMLInputElement).files;

    let flatListFiles = Array.from(file);

    let qtdSelecionada = flatListFiles.length;
    let qtdJaAdd = item.arquivos.length;
    if (qtdSelecionada + qtdJaAdd > 5) {
      this.exibirMensagemAlerta("Não é permitido mais do que 5 arquivos selecionados", false, "");
      return;
    }

    for (let index = 0; index < file.length; index++) {
      const tipo = flatListFiles[index].type.toUpperCase();
      const sizeBytes = flatListFiles[index].size;
      const MAX_ARQUIVO_BYTES = 28 * 1024 * 1024;

      //PDF, PNG, JPG, XLSX e/ou MP4
      //EXCEL OU VND.OPENXMLFORMATS-OFFICEDOCUMENT.SPREADSHEETML.SHEET
      if (tipo.includes("PDF") == false
        && tipo.includes("PNG") == false
        && tipo.includes("JPG") == false
        && tipo.includes("JPEG") == false
        && tipo.includes("MP4") == false
        && tipo.includes("EXCEL") == false
        && tipo.includes("VND.OPENXMLFORMATS-OFFICEDOCUMENT.SPREADSHEETML.SHEET") == false) {
        this.exibirMensagemAlerta("O formato do arquivo deve ser PDF, PNG, JPG, XLSX e/ou MP4", false, "");
        return;
      }

      if (tipo.includes("MP4")) {
        if (sizeBytes > MAX_ARQUIVO_BYTES) {
          this.exibirMensagemAlerta("Não é permitido videos com mais de 28Mb", false, "");
          return;
        }
      }
      else if (sizeBytes > MAX_ARQUIVO_BYTES) {
        this.exibirMensagemAlerta("Não é permitido arquivos com mais de 28Mb", false, "");
        return;
      }

      let fileToArray = await this.getBase64(file[index]);
      let novoArquivo = new IPlanejamentoPapelTrabalhoArquivo();
      novoArquivo.id = 0;
      novoArquivo.nome = flatListFiles[index].name;
      novoArquivo.conteudo = fileToArray.toString();
      novoArquivo.controle = item.arquivos.length + 1;
      novoArquivo.tipo = flatListFiles[index].type;
      item.arquivos.push(novoArquivo)
    }
  }

  public getBase64(file) {
    return new Promise((resolve, reject) => {
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        resolve(reader.result)
      };
      reader.onerror = function (error) {
        Swal.fire({
          toast: true,
          position: 'top-end',
          icon: 'error',
          text: "Ocorreu um erro ao selecionar o arquivo" + error.toString(),
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
        })
      };
    })
  }

  exibeSalvar() {
    return this.model != null && this.model.length > 0;
  }

  async salvar(sair: boolean) {
    if (this.model == null || this.model.length == 0) {
      this.exibirMensagemAlerta('Não tem Papéis de Trabalho do tipo Auditoria.');
      return;
    }
    try {

      const idPlanejamento = this.idPlanejamento ?? this.id;

      for (let i = 0; i < this.model.length; i++) {
        const element = this.model[i];

        if(element.idTipoAceitavel == 2){
          if (element.link && element.link.trim() !== '' && !this.isValidUrl(element.link)) {
            this.exibirMensagemAlerta('O link informado não é válido. Verifique o formato e tente novamente.');
            return;
          }
        }
        element.idPlanejamento = idPlanejamento;
      }

      // Envia conteúdo (base64) apenas dos arquivos novos (id == 0).
      // Arquivos já salvos (id > 0) são reenviados só com metadados, sem o
      // campo conteudo, para não estourar o limite do IIS (~28,6 MB) com 22 papéis.
      const payload = this.model.map((papel) => ({
        ...papel,
        idPlanejamento,
        arquivos: (papel.arquivos ?? []).map((arq) =>
          arq.id > 0 ? { ...arq, conteudo: null } : arq
        ),
      }));

      // Validação do tamanho total estimado do JSON (base64 infla ~33%).
      // Barreira de ~90 MB para ficar abaixo do maxAllowedContentLength de 100 MB.
      const tamanhoEstimado = JSON.stringify(payload).length;
      const MAX_PAYLOAD_CHARS = 90 * 1024 * 1024;
      if (tamanhoEstimado > MAX_PAYLOAD_CHARS) {
        const totalMb = (tamanhoEstimado / 1024 / 1024).toFixed(1);
        this.exibirMensagemAlerta(
          `Volume total (${totalMb} MB) excede o limite de envio. Remova alguns arquivos ou salve em etapas menores.`,
          false,
          ''
        );
        return;
      }

      let res: IBaseModel<void> = null;
      res = await this.planejamentoService.salvarPlanejamentoPapel(payload, this.modelRemovidos, idPlanejamento);

      if (res.sucesso) {
        Swal.fire({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
          icon: 'success',
          text: res.mensagem.descricao
        });

        this.exibirMensagemSucesso(res.mensagem.descricao);

        if (sair)
          this.router.navigate(['/planejamento']);
        else
          this.ngAfterViewInit();

      } else {
        this.exibirMensagemAlerta(res.mensagem.descricao);
      }
    }
    catch (err) {
      const status = err?.status;
      if (status === 413) {
        this.exibirMensagemErro(
          'Volume total excede o limite do servidor (413). Salve em etapas menores ou reduza o tamanho dos arquivos.'
        );
      } else {
        this.exibirMensagemErro(err?.mensagem?.descricao ?? err?.message ?? 'Erro ao salvar papéis de trabalho.');
      }
    }
  }

  mudaTipoAceitavel(tipoAceitavel: number) {

  }

  drop(event: CdkDragDrop<IPlanejamentoPapelTrabalho[]>) {
    moveItemInArray(this.model, event.previousIndex, event.currentIndex);
    this.atualizaPosicoes();
  }

  atualizaPosicoes() {
    for (let i = 0; i < this.model.length; i++) {
      let element = this.model[i];
      element.posicao = i + 1;
    }
  }

  removeFile(item: IPlanejamentoPapelTrabalho, arquivo: IPlanejamentoPapelTrabalhoArquivo) {
    if (arquivo.id == 0) {
      item.arquivos = item.arquivos.filter(f => f.controle != arquivo.controle);
    }
    else {
      //Salva os removidos para remover no banco
      if (item.removidos == null || item.removidos == undefined)
        item.removidos = [];
      item.removidos.push(item.arquivos.find(f => f.id == arquivo.id));

      item.arquivos = item.arquivos.filter(f => f.id != arquivo.id);
    }
  }

  download(arquivo: IPlanejamentoPapelTrabalhoArquivo) {
    const byteString = atob(arquivo.conteudo.replace("data:"+arquivo.tipo+";base64," , ""));
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([int8Array], { type: arquivo.tipo });
    const url= window.URL.createObjectURL(blob);

    this.fileService.downloadFile(url).subscribe((blob) => {
      const a = document.createElement('a');
      const objectUrl = URL.createObjectURL(blob);
      a.href = objectUrl;
      a.download = arquivo.nome;
      a.click();
      URL.revokeObjectURL(objectUrl);
    });
  }

  isValidUrl(value: string): boolean {
    const pattern = /^(https?:\/\/)?([a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z]{2,}))(:\d+)?(\/[^\s]*)?$/;
    return pattern.test(value);
  }

  exibeJustificativa(item: IPlanejamentoPapelTrabalho) {
    if (item.sigla == "PT") {
      return true;
    }
    else {
      if (item.idTipoAceitavel != 2 && (item.arquivos == null || item.arquivos.length == 0)) {
        return true;
      }
      else if (item.idTipoAceitavel == 2 && this.isValidUrl(item.link) == false) {
        return true;
      }
    }

    return false;
  }

  getSigla(item: IPlanejamentoPapelTrabalho) {
    return item.sigla + "-" + (item.posicao).toString().padStart(2, "0");
  }

  async novoPapel() {
    const dialogRef = this.matDialog.open(ModalPapelNaoCadastradoComponent, {
      data: { listPapeis: this.model },
      width: '650px',
      hasBackdrop: true,
      disableClose: true,
      id: 'modal-papel-nao-cadastrado'
    });

    dialogRef.afterClosed().subscribe(async result => {
      if (result) {
        this.atualizaListaAdd(result);
      }
    });
  }

  atualizaListaAdd(nomePapel: string) {
    const novo: IPlanejamentoPapelTrabalho = {
      id: 0,
      idPapel: 0,
      nomePapel: nomePapel,
      nomePapelManual: nomePapel,
      sigla: "PT",
      addManual: true,
      idPlanejamento: 0,
      idTipoAceitavel: 1,
      arquivos: [],
      justificativa: "",
      link: "",
      posicao: this.model.length + 1,
    };
    this.model.push(novo);
  }

  removePapel(item: IPlanejamentoPapelTrabalho) {
    //console.log("removePapel");
    //console.log(this.modelRemovidos);
    //console.log(item);

    if (item.id > 0) {
      this.modelRemovidos.push(this.model.find(f => f.id == item.id));
    }
    else if (item.idPapel > 0) {
      this.modelRemovidos.push(this.model.find(f => f.idPapel == item.idPapel));
    }
    this.model = this.model.filter(f => f.posicao != item.posicao);
    this.atualizaPosicoes();
  }

  getSituacao(item: IPlanejamentoPapelTrabalho) {
    return item.sigla == "PT" ? "" : "(" + item.situacaoNome + ")";
  }

  imprimir() {
    this.router.navigate([`planejamento/${this.id}/planejar/papeis-trabalho/imprimir`], {state: {id: this.id}})
  }

  exibeLink(item: IPlanejamentoPapelTrabalho) {
    return item.idTipoAceitavel == 2;
  }

  exibeRemoverPapel(item: IPlanejamentoPapelTrabalho) {
    return this.visualizar == false && (item.addManual || item.situacaoNome.toUpperCase() == 'OPCIONAL');
  }
}
